import { useState, useEffect } from 'react';
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from 'firebase/firestore';
import { db } from '../firebase';

export default function useHistorico(user) {
  const [historico, setHistorico] = useState([]);

  useEffect(() => {
    if (user) {
      const fetchHistorico = async () => {
        try {
          const historicoTemp = [];

          const qAgenda = query(
            collection(db, 'agenda'),
            where('userId', '==', user.uid),
            orderBy('dataHora', 'desc'),
            limit(5)
          );
          const querySnapshotAgenda = await getDocs(qAgenda);
          querySnapshotAgenda.forEach((doc) => {
            const data = doc.data();
            historicoTemp.push({
              tipo: 'agenda',
              data: data.dataHora.toDate(),
              descricao: `${data.tipo}: ${data.descricao}`,
              detalhes: `Local: ${data.local || 'não informado'}`,
            });
          });

          const qAtendimentos = query(
            collection(db, 'atendimentos'),
            where('userId', '==', user.uid),
            orderBy('dataAtendimento', 'desc'),
            limit(5)
          );
          const querySnapshotAtendimentos = await getDocs(qAtendimentos);
          querySnapshotAtendimentos.forEach((doc) => {
            const data = doc.data();
            historicoTemp.push({
              tipo: 'atendimento',
              data: data.dataAtendimento.toDate(),
              descricao: `Atendimento: ${data.nomePaciente} na ${data.clinica}`,
              detalhes: `Plano de Saúde: ${data.planoSaude || 'não informado'}`,
            });
          });

          const qClinicas = query(
            collection(db, 'clinicas'),
            where('userId', '==', user.uid),
            orderBy('dataCriacao', 'desc'),
            limit(5)
          );
          const querySnapshotClinicas = await getDocs(qClinicas);
          querySnapshotClinicas.forEach((doc) => {
            const data = doc.data();
            historicoTemp.push({
              tipo: 'clinica',
              data: data.dataCriacao?.toDate() || new Date(),
              descricao: `Clínica cadastrada: ${data.nome}`,
              detalhes: `Endereço: ${data.endereco || 'não informado'}`,
            });
          });

          const qPacientes = query(
            collection(db, 'pacientes'),
            where('userId', '==', user.uid),
            orderBy('dataCadastro', 'desc'),
            limit(5)
          );
          const querySnapshotPacientes = await getDocs(qPacientes);
          querySnapshotPacientes.forEach((doc) => {
            const data = doc.data();
            historicoTemp.push({
              tipo: 'paciente',
              data: data.dataCadastro?.toDate() || new Date(),
              descricao: `Paciente cadastrado: ${data.nome}`,
              detalhes: `CPF: ${data.cpf || 'não informado'} | Telefone: ${data.telefone || 'não informado'}`,
            });
          });

          historicoTemp.sort((a, b) => b.data - a.data);
          setHistorico(historicoTemp.slice(0, 10)); // Limitar para os 10 mais recentes
        } catch (e) {
          console.error('Erro ao buscar histórico de uso:', e);
        }
      };

      fetchHistorico();
    }
  }, [user]);

  return { historico };
}
